export const HERO_CONTENT = {
  headline: "Ignite Your Rhythm. Master the Ukulele with Grace.",
  description:
    "Ukulele Seekho is a boutique learning experience for dreamers, creators, and performers. We blend classical techniques with modern artistry so every session feels like a warm sunset jam.",
  primaryCta: {
    label: "View Upcoming Batches",
    href: "#plan-tabs",
  },
  secondaryCta: {
    label: "Book a Trial",
    href: "https://wa.me/9116559114?text=Hi%2C%20I%E2%80%99d%20like%20to%20inquire%20about%20availability%20for%20a%20demo%20class%20this%20week.",
  },
  features: [
    {
      title: "Tailored Learning Paths",
      description: "From absolute beginners to stage-ready performers.",
    },
    {
      title: "Intimate Group Sessions",
      description: "Small batches designed to build confidence and groove.",
    },
    {
      title: "Premium Ukulele Shop",
      description: "Curated instruments and accessories for refined tones.",
    },
  ],
} as const;


